import { ContentLinkNode } from 'src/generated/webapp_gql';
import { contentLinkNodeNavigateTo } from 'src/modules/dashboard/helpers/contentLinkNodeNavigateTo';
import { ContentCardItemWithId } from 'src/shared/ds';
import moment from 'moment';
import i18n from 'src/config/i18n';

export const mapContentLinkToContentCardProps = (
    link: ContentLinkNode,
): ContentCardItemWithId | null => {
    switch (link.__typename) {
        case 'MeditationLinkNode':
            return link.meditation
                ? {
                      id: link.meditation.uuid,
                      title: link.meditation.name,
                      description: i18n.t(`dashboard:meditation.duration`, {
                          duration: link.meditation.duration ?? 1,
                      }),
                      image: link.meditation.image ?? '',
                      onClick: contentLinkNodeNavigateTo(link),
                  }
                : null;
        case 'ProgramLinkNode':
            return link.program
                ? {
                      id: link.program.uuid,
                      title: link.program.name,
                      description: i18n.t(`dashboard:program.duration`, {
                          duration: link.program.duration ?? 1,
                      }),
                      image: link.program.image ?? '',
                      onClick: contentLinkNodeNavigateTo(link),
                  }
                : null;
        case 'CircleSeriesLinkNode':
            return link.circleSeries
                ? {
                      id: link.circleSeries.id,
                      title: link.circleSeries.name,
                      description: i18n.t(`dashboard:circle.topics_with_sessions`, {
                          count: link.circleSeries.topics.edges.length,
                      }),
                      image: link.circleSeries.illustration ?? '',
                      onClick: contentLinkNodeNavigateTo(link),
                  }
                : null;
        case 'ExternalLinkNode':
            return {
                id: link.id,
                title: link.title,
                description: link.subtitle,
                image: link.image,
                onClick: contentLinkNodeNavigateTo(link),
            };
        case 'InternalLinkNode':
            return {
                id: link.id,
                title: link.title,
                description: link.subtitle,
                image: link.image,
                onClick: contentLinkNodeNavigateTo(link),
            };
        case 'CircleSessionLinkNode':
            return link.circleSession
                ? {
                      id: link.circleSession.id,
                      title: link.circleSession.topic.name ?? '',
                      description: i18n.t(`dashboard:circle.seats_left`, {
                          count: link.circleSession.seatsLeft ?? 0,
                      }),
                      image: '',
                      onClick: contentLinkNodeNavigateTo(link),
                  }
                : null;
        case 'CircleTopicLinkNode':
            const firstSessionStartDate = moment(
                link.circleTopic?.sessions.edges[0]?.node.startTime,
            ).format('M/D, h:mm A');
            const numberOfSessions = link.circleTopic?.sessions.edges.length ?? 0;
            return link.circleTopic
                ? {
                      id: link.circleTopic.id,
                      title: link.circleTopic.name ?? '',
                      description: i18n.t(
                          `dashboard:circle.duration.${link.circleTopic.format.toLowerCase()}`,
                          { duration: link.circleTopic.duration },
                      ),
                      image: '',
                      eyebrowText:
                          numberOfSessions > 1
                              ? i18n.t(`dashboard:circle.more_sessions`, {
                                    date: firstSessionStartDate,
                                    count: numberOfSessions - 1,
                                })
                              : firstSessionStartDate,
                      onClick: contentLinkNodeNavigateTo(link),
                  }
                : null;
        default:
            return null;
    }
};
